import { styled } from '@mui/system'
import { TextField } from '@mui/material'

export const StatisticsEditPageMain = styled('main')(({ theme }) => ({
  minHeight: 'calc(100vh - 5rem - 5rem)',
  boxSizing: 'border-box',
  width: 'var(--viewportWidth)',
  padding: '1.6rem',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(auto-fill, minmax(18rem, 1fr))',
  },
}))

export const StatisticsEditPageTileTitle = styled(TextField)(({ theme }) => ({
  display: 'block',
  marginBottom: '1.2rem',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(auto-fill, minmax(18rem, 1fr))',
  },
}))
